document.addEventListener("DOMContentLoaded", function(event) {
	if ($(".product-container").length) {



        // Activate menu items on click //
        $("#product-category-application-sort .dropdown-item").click(function(){
            $("#product-category-application-sort .btn").text("");

            if ($(this).hasClass("active")) {
                $(this).removeClass("active");
            } else {
                $(this).addClass("active");
            }

            $("#product-category-application-sort .dropdown-item.active").each(function(index){
                var dropdownValue = $(this).text();
                if (index === 0) {
                    $("#product-category-application-sort .btn").append(dropdownValue);
                } else {
                    $("#product-category-application-sort .btn").append("|" + dropdownValue);
                }
            });

            if ($("#product-category-application-sort .btn").text() == "") {
                $("#product-category-application-sort .btn").text("Applications");
            }
        });



        $("#product-category-product-sort .dropdown-item").click(function(){
            $("#product-category-product-sort .btn").text($(this).text());

            $("#product-category-product-sort .dropdown-item").removeClass("active");
            $(this).addClass("active");
        });
        // End // 



        // Clear Filter //
            $(".clear-filter").click(function(){
                $("#product-search-field input").val("");
                $('.no-results').addClass('d-none');

                var inputValue = $("#product-search-field input").val().toLowerCase() + "|";
                var totalValue = inputValue;
                var result = totalValue.split("|");
                result = result.filter(item => item);
    
                $(".product-wrapper").removeClass("d-none");
    
                if (result.length) {
                    $.each(result, function(index, value){
                        var valueLC = value.toLowerCase();
    
                        $(".product-wrapper:not([data-tags*='"+valueLC+"' i])").addClass("d-none");
                    });
                }
                
                $(".input-clear input").val("");
                // End //
            });
        // End //



        // Filtering //
		$("#product-search-field input, #product-category-application-sort .dropdown-item, #product-search-field .btn").on("keyup click", function() {

            // Update Results //
			var inputValue = $("#product-search-field input").val().toLowerCase() + "|";
            var dropdownApplicationValue = $("#product-category-application-sort .btn").text().toLowerCase();
            if (dropdownApplicationValue === "applications") {
                dropdownApplicationValue = "";
            }
			var totalValue = inputValue + dropdownApplicationValue;
			var result = totalValue.split("|");
			result = result.filter(item => item);

			$(".product-wrapper").removeClass("d-none");

			if (result.length) {
				$.each(result, function(index, value){
					var valueLC = value.toLowerCase();

					$(".product-wrapper:not([data-tags*='"+valueLC+"' i])").addClass("d-none");
				});
			}
            // End //

            if ($('.product-wrapper:not(.d-none)').length === 0) {
                $('.no-results').removeClass('d-none');
            } else {
                $('.no-results').addClass('d-none');
            }
		});
        // End //
        


        $(".product-container").removeClass("d-none");


        
		$("#product-category-product-sort .dropdown-item").on("click", function() {
            const productGrid = document.querySelector(".product-container");

            const selectedValue = $(this).attr("data-value");
            const products = Array.from(productGrid.getElementsByClassName("product-wrapper"));
        
            if (selectedValue === "nameasc") {
                products.sort((a, b) => {
                    const nameA = a.querySelector(".price").textContent.toLowerCase();
                    const nameB = b.querySelector(".price").textContent.toLowerCase();
                    return nameA.localeCompare(nameB);
                });
            } else if (selectedValue === "namedesc") {
                products.sort((a, b) => {
                    const nameA = a.querySelector(".price").textContent.toLowerCase();
                    const nameB = b.querySelector(".price").textContent.toLowerCase();
                    return nameB.localeCompare(nameA);
                });
            } else if (selectedValue === "categoryasc") {
                products.sort((a, b) => {
                    const categoryA = a.querySelector(".title").textContent.toLowerCase();
                    const categoryB = b.querySelector(".title").textContent.toLowerCase();
                    return categoryA.localeCompare(categoryB);
                });
            } else if (selectedValue === "categorydesc") {
                products.sort((a, b) => {
                    const categoryA = a.querySelector(".title").textContent.toLowerCase();
                    const categoryB = b.querySelector(".title").textContent.toLowerCase();
                    return categoryB.localeCompare(categoryA);
                });
            }
            
            products.forEach(product => productGrid.appendChild(product));
        });
	}
});